<mat-stepper [linear]="true" #stepper>
  <mat-step [completed]="false" [stepControl]="consentForm" #firstStep>
    <ng-template matStepLabel>Veuillez remplir les données</ng-template>
    <h1 class="text-center text-responsive" id="header">
      {{textConfig?.pageOneFirstTitle}}
    </h1>
    <div class="col-sm-12 col-md-12" id="text">
      <h2 class="text-responsive">{{textConfig?.pageOneSecondTitle}}</h2>
      <h3 class="text-responsive">
        {{textConfig?.pageOneThirdTitle}}</h3>
      <div [innerHTML]="textConfig?.pageOneBodyText">
      </div>
    </div>
    <div id="form">
      <div class="row" id="form-header">
        <h2 class="offset-sm-1 offset-md-4 col-sm-4 text-responsive">Informations obligatoires à remplir :</h2>
      </div>
      <ng-template [ngIf]="state == 'loading'">
        <mat-progress-spinner style="margin: auto;" mode="indeterminate"></mat-progress-spinner>
      </ng-template>
      <form id="consentmentForm" *ngIf="state == 'loaded'" [formGroup]="consentForm" class="col-sm-12 ml-5" #ngForm="ngForm">
        <div id="inputContainer" class="row" *ngFor="let row of formTemplateArray; let rowIndex = index">
          <div [ngClass]="columnIndex > 0 ? 'offset-lg-2' : ''" class="col-sm-2 form-group" *ngFor="let column of row; let columnIndex = index">
            <!-- Calculate the actual index for accessing formData -->
            <ng-container *ngIf="formData && (columnIndex + (inputPerRow * rowIndex)) < formData.length">
              <div [ngStyle]="{'cursor': column.disabled ? 'not-allowed' : '' }" *ngIf="!formData[columnIndex + (inputPerRow * rowIndex)].options || formData[columnIndex + (inputPerRow * rowIndex)].options == ''">
                <div>
                  <label [for]="formData[columnIndex + (inputPerRow * rowIndex)].name">
                    {{formData[columnIndex + (inputPerRow * rowIndex)].label}}
                    <span style="color: red" *ngIf="formData[columnIndex + (inputPerRow * rowIndex)].required == 'true'">
                      *
                    </span>
                    <span *ngIf="formData[columnIndex + (inputPerRow * rowIndex)].required == 'false'">
                      (Facultatif)
                    </span>
                    :
                  </label>
                  <input [autocomplete]="formData[columnIndex + (inputPerRow * rowIndex)].autocomplete"
                         type="text"
                         [ngClass]="{'is-invalid': ngForm.submitted && column.errors}"
                         class="form-control"
                         [id]="formData[columnIndex + (inputPerRow * rowIndex)].name"
                         [formControl]="column">
                  <div class="invalid-feedback">
                    <div *ngIf="column.errors?.required">
                      Ce champs est obligatoire.
                    </div>
                    <div *ngIf="column.errors?.pattern">
                      {{formData[columnIndex + (inputPerRow * rowIndex)].validationErrorMessage}}
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="formData[columnIndex + (inputPerRow * rowIndex)].options && formData[columnIndex + (inputPerRow * rowIndex)].options != ''">
                <label [for]="formData[columnIndex + (inputPerRow * rowIndex)].name">{{formData[columnIndex + (inputPerRow * rowIndex)].label}}</label>
                <select [ngClass]="{'is-invalid': ngForm.submitted && column.errors}"
                        class="form-control"
                        aria-label="Default select example"
                        [formControl]="column">
                  <option *ngFor="let option of extractOptions(formData[columnIndex + (inputPerRow * rowIndex)].options)" [value]="option">
                    {{option}}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Ce champs est obligatoire.
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div>
          (<span style="color: red">*</span>) À renseigner obligatoirement
        </div>
        <div class="offset-sm-7 offset-md-10">
          <button id="nextButton" color="primary" mat-raised-button matStepperNext>Suivant</button>
        </div>
      </form>
    </div>
  </mat-step>
  <mat-step [completed]="false" [stepControl]="confirmForm" #secondStep>
    <ng-template matStepLabel>Confirmation</ng-template>

    <!-- Titre principal avec classes Bootstrap pour différentes tailles d'écran -->
    <h1 class="text-center mb-4 mt-3 fs-5 fs-sm-4 fs-md-3">
      {{textConfig?.pageTwoFirstTitle}}
    </h1>

    <div id="confirmationForm" class="container-fluid px-2 px-sm-3 px-md-4">
      <div class="row" id="confirmFormHeader">
        <form [formGroup]="confirmForm" class="col-12" #confirmFormHTML="ngForm">

          <!-- Section de consentement -->
          <div class="row align-items-center mb-4">
            <div class="col-2 col-sm-2 col-md-1 text-center">
              <mat-checkbox
                required="true"
                color="primary"
                [ngClass]="{'is-invalid': confirmFormHTML.submitted && confirmForm.get('consent')?.errors}"
                class="mt-2"
                formControlName="consent">
              </mat-checkbox>
            </div>

            <div class="col-10 col-sm-10 col-md-11 col-lg-8">
              <h2 class="fs-6 fs-sm-5 fs-lg-4">
                {{textConfig?.pageTwoSecondTitle}}
              </h2>
              <p class="mb-0 small text-sm-normal">
                {{textConfig?.pageTwoBodyText}}
              </p>
            </div>
          </div>

          <!-- Boutons de navigation -->
          <div class="row mt-4 mb-3">
            <div class="col-6 col-sm-6 text-start">
              <button mat-raised-button matStepperPrevious class="w-auto">Précédent</button>
            </div>
            <div class="col-6 col-sm-6 text-end">
              <button (click)="accept()" color="primary" mat-raised-button matStepperNext class="w-auto">J'accepte</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </mat-step>
  <mat-step [completed]="false">
    <ng-template matStepLabel>Terminé</ng-template>

    <div class="container">
      <div class="row justify-content-center align-items-start mt-4">
        <div class="col-md-6">
          <div class="confirmation-content">
            <h2 class="success-title">{{textConfig?.pageThreeSecondTitle}}</h2>
            <p class="confirmation-text">{{textConfig?.pageThreeBodyText}}</p>
          </div>
        </div>
      </div>
    </div>

  </mat-step>
</mat-stepper>
